module.exports = __webpack_public_path__ + "static/1-cf109cd2889f90c62aa94ed988d484a1.jpg";